import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Bảy phòng gặp khách tận nơi (hợp đồng khachdep.v1 §8, CEO chốt 26/09/2026).
 *
 * Bản sao của `beautynom.NominateDepts` ở máy chủ. Hai bản phải khớp nhau:
 * rộng hơn thì người dùng thấy nút rồi lĩnh 403, hẹp hơn thì đúng những người
 * cần nó nhất lại không thấy nút. Bài kiểm ở
 * `__tests__/permissions.test.ts` giữ danh sách này khớp với cổng máy chủ.
 */
const NOMINATE_DEPTS = [
  "photo_idphoto",
  "photo_profile",
  "photo_corporate",
  "makeup",
  "retouch",
  "reception",
  "cskh",
] as const;

/**
 * Ai THẤY nút "Khách đẹp".
 *
 * Hợp đồng §8 nói rõ: ai không thuộc danh sách thì KHÔNG THẤY nút — chứ không
 * phải thấy rồi bấm mới báo lỗi. Một cái nút chỉ để từ chối người bấm là một
 * cái nút nói dối.
 *
 * Khớp cổng máy chủ `AllowOrDept("customer.beauty.write", …7 phòng)`: hoặc
 * cầm quyền (vai quản lý trở lên), hoặc thuộc một trong bảy phòng đó — bảy
 * phòng ấy mang vai `staff`, vai dùng chung cho mọi phòng vận hành, nên
 * không thể cấp quyền theo vai mà không mở cho cả những người không gặp khách.
 */
export function canNominateBeauty(staff: Staff | null): boolean {
  if (!staff) return false;
  const dept = staff.department?.toLowerCase().trim() ?? "";
  if ((NOMINATE_DEPTS as readonly string[]).includes(dept)) return true;
  return hasPermission(ACTION.CustomerBeautyWrite);
}

export { NOMINATE_DEPTS };
